<template>
    <div class="btn-group" role="group">
        <button type="button" class="btn btn-outline-primary" :class="{ active: active === 'today' }" @click="apply('today')">Сегодня</button>
        <button type="button" class="btn btn-outline-primary" :class="{ active: active === 'oneWeekAgo' }" @click="apply('oneWeekAgo')">Неделя</button>
        <button type="button" class="btn btn-outline-primary" :class="{ active: active === 'oneMonthAgo' }" @click="apply('oneMonthAgo')">Месяц</button>
    </div>
</template>

<script>
import { subDays, subMonths, isEqual, isDate, parse, format } from 'date-fns'

export default {
    props: {
        value: {
            type: Object,
            default: _ => ({ since: null, until: null })
        }
    },

    computed: {
        since() {
            return this.value.since
        },

        until() {
            return this.value.until
        },

        sinceTrunc() {
            if (!this.since) {
                return null
            }

            return isDate(this.since)
                ? this.since.setHours(0, 0, 0, 0)
                : parse(this.since)
        },

        untilTrunc() {
            if (!this.until) {
                return null
            }

            return isDate(this.until)
                ? this.until.setHours(0, 0, 0, 0)
                : parse(this.until)
        },

        active() {
            if (!this.sinceTrunc || !this.untilTrunc) {
                return null
            }

            const now = new Date()
            now.setHours(0, 0, 0, 0)

            if (isEqual(this.sinceTrunc, now) && isEqual(this.untilTrunc, now)) {
                return 'today'
            }

            if (isEqual(this.sinceTrunc, subDays(now, 7)) && isEqual(this.untilTrunc, now)) {
                return 'oneWeekAgo'
            }

            if (isEqual(this.sinceTrunc, subMonths(now, 1)) && isEqual(this.untilTrunc, now)) {
                return 'oneMonthAgo'
            }

            return null
        }
    },

    methods: {
        emit(since, until, alias) {
            this.$emit('input', {
                since: isDate(this.since) ? since : format(since, 'YYYY-MM-DD'),
                until: isDate(this.until) ? until : format(until, 'YYYY-MM-DD'),
                alias
            })
        },

        apply(alias) {
            const now = new Date()
            now.setHours(0, 0, 0, 0)

            if (alias === 'today') {
                return this.emit(now, now, alias)
            }

            if (alias === 'oneWeekAgo') {
                return this.emit(subDays(now, 7), now, alias)
            }

            if (alias === 'oneMonthAgo') {
                return this.emit(subMonths(now, 1), now, alias)
            }
        }
    }
}
</script>
